/**
 * Finalización del peritaje desde la vista del perito.
 *
 * El backend no finaliza si faltan datos y devuelve el motivo en `message`.
 * Ese motivo se expone como `faltantes` para mostrarlo en un modal; el
 * perito corrige, reintenta y sólo entonces se navega al reporte.
 */
import { useCallback, useState } from 'react';
import { get } from '../services/back.service';

export default function useFinishInspection({ inspectionId, onSuccess }) {
  const [faltantes, setFaltantes] = useState(null);

  const finish = useCallback(async () => {
    const respo = await get(`/peritaje/finishinspect/${inspectionId}`, {});

    if (respo.success) {
      setFaltantes(null);
      onSuccess();
      return true;
    }

    setFaltantes(respo.message);
    return false;
  }, [inspectionId, onSuccess]);

  const closeFaltantes = useCallback(() => setFaltantes(null), []);

  return { faltantes, finish, closeFaltantes };
}
